<template>
  <div>
    <el-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">{{ $t('shu-ju-zhong-xin') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('shu-ju-dao-chu') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
  </div>
</template>

<script>
  export default {
    name: 'dataExport'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/dataCenter/page/dataExport.vue